// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/financial/tax_exemption_info.proto (package carmen, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import { file_proto_model_financial_tax_jurisdiction } from "./tax_jurisdiction_pb";
import { file_proto_model_financial_financial_types } from "./financial_types_pb";

/**
 * Describes the file proto/model/financial/tax_exemption_info.proto.
 */
export const file_proto_model_financial_tax_exemption_info = /*@__PURE__*/
  fileDesc("Ci5wcm90by9tb2RlbC9maW5hbmNpYWwvdGF4X2V4ZW1wdGlvbl9pbmZvLnByb3RvEgZjYXJtZW4i8QMKEFRheEV4ZW1wdGlvbkluZm8SMAoOZXhlbXB0aW9uX3R5cGUYASABKA4yGC5jYXJtZW4uVGF4RXhlbXB0aW9uVHlwZRIaChJjZXJ0aWZpY2F0ZV9udW1iZXIYAiABKAkSGQoRaXNzdWluZ19hdXRob3JpdHkYAyABKAkSLgoKdmFsaWRfZnJvbRgEIAEoCzIaLmdvb2dsZS5wcm90b2J1Zi5UaW1lc3RhbXASLwoLdmFsaWRfdW50aWwYBSABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEjMKEnZhbGlkX2p1cmlzZGljdGlvbhgGIAEoCzIXLmNhcm1lbi5UYXhKdXJpc2RpY3Rpb24SEwoLaXNfdmVyaWZpZWQYByABKAgSLAoIdmVyaWZpZWQYCCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wEhMKC3ZlcmlmaWVkX2J5GAkgASgJEhsKE2RvY3VtZW50YXRpb25fbm90ZXMYCiABKAkSOAoIbWV0YWRhdGEYCyADKAsyJi5jYXJtZW4uVGF4RXhlbXB0aW9uSW5mby5NZXRhZGF0YUVudHJ5Gi8KDU1ldGFkYXRhRW50cnkSCwoDa2V5GAEgASgJEg0KBXZhbHVlGAIgASgJOgI4AUIoWiZnaXRodWIuY29tL3l1bmFjYWJhL2Nhcm1lbi9wcm90by9tb2RlbGIGcHJvdG8z", [file_google_protobuf_timestamp, file_proto_model_financial_tax_jurisdiction, file_proto_model_financial_financial_types]);

/**
 * Describes the message carmen.TaxExemptionInfo.
 * Use `create(TaxExemptionInfoSchema)` to create a new message.
 */
export const TaxExemptionInfoSchema = /*@__PURE__*/
  messageDesc(file_proto_model_financial_tax_exemption_info, 0);

